<app-lms-modal-frame [title]="'Address Details'" [pageHeadWidth]="600">
  <div modal-body>
    <div class="container-fluid center-screen">
      <table w650 id="clientHeader" class="table table-sm shadow-2-strong rounded-1">
        <caption>Client Details</caption>
        <tbody>
          <tr>
            <td>First names</td>
            <td>{{clientDetails.firstName}}</td>

            <td>Surname</td>
            <td>{{clientDetails.lastName}}</td>
          </tr>

          <tr>
            <td>ID number</td>
            <td>{{clientDetails.idNumber}}</td>

            <td>Cell number</td>
            <td>{{clientDetails.cellNumber}}</td>
          </tr>
        </tbody>
      </table>
    </div>
      <div class="row center-screen align-items-center">
            <ng-container class="row center-screen mt-0">
            <div *ngIf="hasAddress">
              <table w750 class="mt-1 mb-0 table table-borderless table-sm table-fixed" style="max-width: 600px;" [style.width.px]="750">
                <tbody>
                  <tr>
                    <td class="aligndetails" style="border-bottom-width: 0;">
                      <!--  Home Address -->
                      <table id="homeAddress" class="table table-striped table-sm shadow-2-strong rounded-1">
                        <caption *ngIf="!addressModel.sameAsAddress">Residential Address</caption>
                        <caption *ngIf="addressModel.sameAsAddress">Residential and Postal address</caption>

                        <tbody class="field-4column-label">
                          <tr>
                            <td>Address line 1</td>
                            <td>{{homeAddress.line1}}</td>
                          </tr>

                          <tr>
                            <td> Address line 2</td>
                            <td>{{homeAddress.line2}}</td>
                          </tr>
                          <tr>
                            <td>Suburb</td>
                            <td>{{homeAddress.suburb}}</td>
                          </tr>
                          <tr>
                            <td>Town / City</td>
                            <td>{{homeAddress.town}}</td>
                          </tr>
                          <tr>
                            <td>Area code</td>
                            <td>{{homeAddress.code}}</td>
                          </tr>

                          <tr>
                            <td> Province</td>
                            <td>{{homeAddress.province}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>

                    <td class="aligndetails" style="border-bottom-width: 0;"
                      *ngIf="!addressModel.sameAsAddress">
                      <!--  POSTAL Address -->
                      <table id="postalAddressDetails" class="table table-striped table-sm shadow-2-strong rounded-1 mt-0">
                        <caption>Postal Address</caption>

                        <tbody class="field-4column-label">
                          <tr>
                            <td>Postal address line 1</td>
                            <td>{{postalAddress.line1}}</td>
                          </tr>

                          <tr *ngIf="postalAddress.line2">
                            <td>Postal address line 2</td>
                            <td>{{postalAddress.line2}}</td>
                          </tr>
                          <tr>
                            <td>Suburb</td>
                            <td>{{postalAddress.suburb}}</td>
                          </tr>
                          <tr>
                            <td>Town / City</td>
                            <td>{{postalAddress.town}}</td>
                          </tr>

                          <tr>
                            <td>Area code</td>
                            <td>{{postalAddress.code}}</td>
                          </tr>
                          <tr>
                            <td> Province</td>
                            <td>{{postalAddress.province}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- NO address details (EDITING)-->
            <div *ngIf="!hasAddress && !isReadOnly">
              <div class="row center-screen">
                <table class="mt-0 mb-0 table table-sm table-fixed" [style.width.px]="750">
                  <tbody>
                    <tr>
                      <td class="aligndetails" style="border-bottom-width: 0;">
                        <form [formGroup]="addressDetailsForm" >
                        <!-- Home and Postal address -->
                        <table class="table p-1 table-striped table-bordered table-sm shadow-2-strong rounded-1 mt-0"
                          [ngClass]="{'myw-400':addressModel.sameAsAddress}">
                          <caption *ngIf="addressModel.sameAsAddress">Residential and Postal address</caption>
                          <caption *ngIf="!addressModel.sameAsAddress">Residential address</caption>

                          <tbody class="field-4column-label">
                            <tr>
                              <td>Address line 1</td>
                              <td>
                                <input class="form-control" placeholder="Address line 1"
                                  formControlName="homeAdressLine1"
                                  required type="text" lmsNoSpecials>
                                <div
                                  *ngIf="validateAddressesInput.homeAdressLine1.errors?.required && validateAddressesInput.homeAdressLine1.touched && submitted">
                                  <small *ngIf="validateAddressesInput.homeAdressLine1.errors?.required"
                                    class="text-danger">
                                    Address line 1 is required
                                  </small>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>Address line 2</td>
                              <td>
                                <input class="form-control" placeholder="Address line 2"
                                  formControlName="homeAdressLine2"
                                  type="text" lmsNoSpecials>
                              </td>
                            </tr>

                              <tr>
                                <td>Suburb</td>
                                  <td style="width: 120px;">
                                    <input class="form-control" formControlName="homeAdressSuburb" placeholder="Suburb *"
                                      required type="text"
                                      (keypress)="preventDigitsAndSpecialChars($event)"
                                      (input)="preventDigitsAndSpecialCharsOnInput($event)">
                                    <div
                                      *ngIf="validateAddressesInput.homeAdressSuburb.errors?.required && validateAddressesInput.homeAdressSuburb.touched && submitted">
                                      <small *ngIf="validateAddressesInput.homeAdressSuburb.errors?.required"
                                        class="text-danger">
                                        Suburb is required
                                      </small>
                                    </div>
                                    <div *ngIf="validateAddressesInput.homeAdressSuburb.errors?.pattern && submitted">
                                      <small class="text-danger">
                                        Suburb should only contain letters and spaces
                                      </small>
                                    </div>
                                  </td>
                              <tr>
                                <td>Town/City</td>
                                  <td style="width: 120px;">
                                    <input class="form-control" placeholder="Town/City" formControlName="homeAdressTown"
                                      required type="text"
                                      (keypress)="preventDigitsAndSpecialChars($event)"
                                      (input)="preventDigitsAndSpecialCharsOnInput($event)">
                                    <div *ngIf="validateAddressesInput.homeAdressTown.errors?.required && submitted">
                                      <small *ngIf="validateAddressesInput.homeAdressTown.errors?.required"
                                        class="text-danger">
                                        Town/City is required
                                      </small>
                                    </div>
                                    <div *ngIf="validateAddressesInput.homeAdressTown.errors?.pattern && submitted">
                                      <small class="text-danger">
                                        Town/City should only contain letters and spaces
                                      </small>
                                    </div>
                                  </td>
                              </tr>

                            <tr>
                              <td>Area code</td>
                              <td style="width: 120px;">
                                <input class="form-control" formControlName="homeAdressAreaCode"
                                  placeholder="Area code *" required
                                  maxlength="4" type="text"
                                  (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                                  (input)="removeSpaces($event)"
                                  pattern="[0-9]{4}">
                                <div
                                  *ngIf="validateAddressesInput.homeAdressAreaCode.errors?.required && submitted">
                                  <small *ngIf="validateAddressesInput.homeAdressAreaCode.errors?.required"
                                    class="text-danger">
                                    Area code is required
                                  </small>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td> Province</td>
                              <td>
                                <mdb-select class="select table-control"
                                  formControlName="homeAdressProvince"
                                  required>
                                  <mdb-option value="Gauteng">Gauteng</mdb-option>
                                  <mdb-option value="KwaZulu-Natal">KwaZulu-Natal</mdb-option>
                                  <mdb-option value="Free-State">Free State</mdb-option>
                                  <mdb-option value="Eastern-cape">Eastern Cape</mdb-option>
                                  <mdb-option value="Limpopo">Limpopo</mdb-option>
                                  <mdb-option value="Mpumalanga">Mpumalanga</mdb-option>
                                  <mdb-option value="North West">North West</mdb-option>
                                  <mdb-option value="Northern-Cape">Northern Cape</mdb-option>
                                  <mdb-option value="Western-Cape">Western Cape</mdb-option>
                                </mdb-select>
                                <div *ngIf="validateAddressesInput.homeAdressProvince.errors?.required && submitted">
                                  <small *ngIf="validateAddressesInput.homeAdressProvince.errors?.required"
                                    class="text-danger">
                                    Province is required
                                  </small>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        </form>
                      </td>

                        <!-- NOT sameAddress-->
                        <td class="aligndetails" *ngIf="!addressModel.sameAsAddress" style="border-bottom-width: 0;" >
                          <form [formGroup]="postalDetailsForm" >
                            <!--  POSTAL Address -->
                            <table class="table p-1 table-striped table-bordered table-sm shadow-2-strong rounded-1">
                              <caption>Postal Address</caption>
                              <tbody class="field-4column-label">
                                <tr>
                                  <td>Address type</td>
                                  <td>
                                    <span>
                                      <div class="d-flex align-items-center justify-content-around">
                                        <input class="form-control-sm mdc-radio radio-button form-radio-input "
                                          id="POSTAL" name="postalType" type="radio" value="POSTAL"
                                          (click)="_postalType = 'POSTAL'">
                                        <label for="POSTAL"> Postal </label>
                                        <input class="form-control-sm mdc-radio form-radio-input" id="HOME"
                                          name="postalType" type="radio" value="HOME" (click)="_postalType = 'HOME'">
                                        <label for="HOME"> Residential </label>
                                      </div>
                                    </span>
                                  </td>
                                </tr>
                                <tr *ngIf="postalType !== 'HOME'">
                                  <td>Box number</td>
                                  <td>
                                    <input class="form-control" placeholder="Box Number"
                                      formControlName="postalAdressLine1"
                                      required type="text" lmsNoSpecials>
                                    <div
                                      *ngIf="validatePostalAddressesInput.postalAdressLine1.errors?.required && submitted">
                                      <small *ngIf="validatePostalAddressesInput.postalAdressLine1.errors?.required"
                                        class="text-danger">
                                        PO Box number is required
                                      </small>
                                    </div>
                                  </td>
                                </tr>
                                <tr *ngIf="postalType === 'HOME'">
                                  <td>Address line 1</td>
                                  <td>
                                    <input class="form-control" placeholder="Address line 1"
                                      formControlName="postalAdressLine1"
                                      required type="text" lmsNoSpecials>
                                    <div
                                      *ngIf="validatePostalAddressesInput.postalAdressLine1.errors?.required && submitted">
                                      <small *ngIf="validatePostalAddressesInput.postalAdressLine1.errors?.required"
                                        class="text-danger">
                                        Address line 1 is required
                                      </small>
                                    </div>
                                  </td>
                                </tr>
                                <tr *ngIf="postalType === 'HOME'">
                                  <td>Address line 2</td>
                                  <td>
                                    <input class="form-control" placeholder="Address line 2"
                                      formControlName="postalAdressLine2"
                                      type="text" lmsNoSpecials>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Suburb</td>
                                    <td style="width: 120px;">
                                      <input class="form-control" formControlName="postalAdressSuburb"
                                        placeholder="Suburb *"  required
                                        type="text"
                                        (keypress)="preventDigitsAndSpecialChars($event)"
                                        (input)="preventDigitsAndSpecialCharsOnInput($event)">
                                      <div
                                        *ngIf="validatePostalAddressesInput.postalAdressSuburb.errors?.required && validatePostalAddressesInput.postalAdressSuburb.touched && submitted">
                                        <small *ngIf="validatePostalAddressesInput.postalAdressSuburb.errors?.required"
                                          class="text-danger">
                                          Suburb is required
                                        </small>
                                      </div>
                                      <div *ngIf="validatePostalAddressesInput.postalAdressSuburb.errors?.pattern && submitted">
                                        <small class="text-danger">
                                          Suburb should only contain letters and spaces
                                        </small>
                                      </div>
                                    </td>
                                </tr>
                                <tr>
                                  <td>Town/City</td>
                                    <td style="width: 120px;">
                                      <input class="form-control" placeholder="Town/City"
                                        formControlName="postalAdressTown"
                                        required type="text"
                                        (keypress)="preventDigitsAndSpecialChars($event)"
                                        (input)="preventDigitsAndSpecialCharsOnInput($event)">
                                      <div
                                        *ngIf="validatePostalAddressesInput.postalAdressTown.errors?.required && submitted">
                                        <small *ngIf="validatePostalAddressesInput.postalAdressTown.errors?.required"
                                          class="text-danger">
                                          Town/City is required
                                        </small>
                                      </div>
                                      <div *ngIf="validatePostalAddressesInput.postalAdressTown.errors?.pattern && submitted">
                                        <small class="text-danger">
                                          Town/City should only contain letters and spaces
                                        </small>
                                      </div>
                                    </td>
                                </tr>
                                <tr>
                                  <td>Area code</td>
                                  <td>
                                    <input class="form-control" maxlength="4" placeholder="Area Code"
                                      formControlName="postalAdressAreaCode"
                                      required
                                      (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                                      (input)="removeSpaces($event)"
                                      pattern="[0-9]{4}">
                                    <div
                                      *ngIf="(validatePostalAddressesInput.postalAdressAreaCode.errors?.required || validatePostalAddressesInput.postalAdressAreaCode.errors?.pattern) && submitted">
                                      <small *ngIf="validatePostalAddressesInput.postalAdressAreaCode.errors?.required"
                                        class="text-danger">
                                        Area code is required
                                      </small>
                                      <small *ngIf="validatePostalAddressesInput.postalAdressAreaCode.errors?.pattern"
                                        class="text-danger">
                                        Invalid Area Code
                                      </small>
                                    </div>
                                  </td>
                                </tr>

                              <tr>
                                <td> Province</td>
                                <td>
                                  <mdb-select class="select table-control"
                                  formControlName="postalAdressProvince"
                                  required>
                                  <mdb-option value="Gauteng">Gauteng</mdb-option>
                                  <mdb-option value="KwaZulu-Natal">KwaZulu-Natal</mdb-option>
                                  <mdb-option value="Free-State">Free State</mdb-option>
                                  <mdb-option value="Eastern-cape">Eastern Cape</mdb-option>
                                  <mdb-option value="Limpopo">Limpopo</mdb-option>
                                  <mdb-option value="Mpumalanga">Mpumalanga</mdb-option>
                                  <mdb-option value="North West">North West</mdb-option>
                                  <mdb-option value="Northern-Cape">Northern Cape</mdb-option>
                                  <mdb-option value="Western-Cape">Western Cape</mdb-option>
                                </mdb-select>
                                  <div
                                    *ngIf="validatePostalAddressesInput.postalAdressProvince.errors?.required && submitted">
                                    <small *ngIf="validatePostalAddressesInput.postalAdressProvince.errors?.required"
                                      class="text-danger">
                                      Province is required
                                    </small>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </form>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- NOT sameAdddres end-->
                <div class="d-flex justify-content-center my-2">
                  <div class="form-check-reverse check-end form-check-inline my-1">
                    <input mdbCheckbox class="form-check-input" id="sameAddress" type="checkbox" [(ngModel)]="addressModel.sameAsAddress"/>
                    <label class="form-check-label px-2" for="sameAddress">
                      Postal address is the same as residential address
                    </label>
                  </div>
                </div>
              </div>
            </div>
            </ng-container>
      </div>
  </div>
  <div modal-actions class="flex-container">
    <button type="button" class="btn btn-primary" (click)="close()">Close</button>
    <button type="button" class="btn btn-primary" *ngIf="!isReadOnly && !hasAddress" (click)="saveAddress()">Save</button>
    <button type="button" class="btn btn-primary" *ngIf="hasAddress && !isReadOnly" (click)="hasAddress = false;">Edit</button>
    <button type="button" *ngIf="!isReadOnly && hasAddress" class="btn btn-primary ms-4"
      (click)="confirmAddDetails()"><i class="fas fa-thumbs-up fa-fw me-1"></i> Confirm</button>
  </div>
</app-lms-modal-frame>
